"use strict";
import { uniswapUrls } from "constants/urls";
import { createApiClient } from "data/apiClients/createApiClient";
import { createSignedRequestBody, createSignedRequestParams } from "data/utils";
const UnitagsApiClient = createApiClient({
  baseUrl: uniswapUrls.unitagsApiUrl
});
export async function fetchUsername(_params) {
  return { available: false, requiresEnsMatch: false };
}
export async function fetchAddress(_params) {
  return {};
}
export async function fetchUnitagsByAddresses({ addresses: _addresses }) {
  return { usernames: {} };
}
export async function fetchClaimEligibility(_params) {
  return { canClaim: false };
}
export async function claimUnitag({
  data,
  address,
  signMessage
}) {
  const { requestBody, signature } = await createSignedRequestBody({
    data,
    address,
    signMessage
  });
  return await UnitagsApiClient.post("/username", {
    body: JSON.stringify(requestBody),
    headers: {
      "x-uni-sig": signature
    }
  });
}
export async function updateUnitagMetadata({
  username,
  data,
  address,
  signMessage
}) {
  const { requestBody, signature } = await createSignedRequestBody({
    data,
    address,
    signMessage
  });
  return await UnitagsApiClient.put(`/username/${username}/metadata`, {
    body: JSON.stringify(requestBody),
    headers: {
      "x-uni-sig": signature
    }
  });
}
export async function changeUnitag({
  data,
  address,
  signMessage
}) {
  const { requestBody, signature } = await createSignedRequestBody({
    data,
    address,
    signMessage
  });
  return await UnitagsApiClient.post("/username/change", {
    body: JSON.stringify(requestBody),
    headers: {
      "x-uni-sig": signature
    }
  });
}
export async function deleteUnitag({
  data,
  address,
  signMessage
}) {
  const { requestBody, signature } = await createSignedRequestBody({
    data,
    address,
    signMessage
  });
  return UnitagsApiClient.delete("/username", {
    body: JSON.stringify(requestBody),
    headers: {
      "x-uni-sig": signature
    }
  });
}
export async function getUnitagAvatarUploadUrl({
  data,
  address,
  signMessage
}) {
  const { requestParams, signature } = await createSignedRequestParams({ data, address, signMessage });
  return await UnitagsApiClient.get("/username/avatar-upload-url", {
    params: requestParams,
    headers: {
      "x-uni-sig": signature
    }
  });
}
